export default "__VITE_ASSET__1a89233f__"